import React, { useEffect, useState } from "react";
import { getDictionaryItems } from "../api/dictionary";
import RegionDistrictInput from "./RegionDistrictInput";

const SYNCED_FIELDS = [

  "Официальное название организации",

  "Регистрационный номер",

  "ИНН",

  "Область",

  "Район",

  "Адрес",

  "Номер телефона руководителя медицинского учреждения",

  "Почтовый адрес руководителя медицинского учреждения",
];

export default function FieldInput({ field, value, onChange, formData, lang, isEditing, isDisabledCustom, dictionary_id, }) {
  const [options, setOptions] = useState([]);
  const isRequired = field.is_required;
//  const [tempValue, setTempValue] = useState("");
  const [customValue, setCustomValue] = useState("");


  useEffect(() => {
    const dictId = dictionary_id || field.dictionary;

    if (dictId) {
      getDictionaryItems(dictId).then((res) => {
        setOptions(res.data);
      });
    }
  }, [dictionary_id, field.dictionary]);

  let isDisabled = isDisabledCustom || false;

  const isSyncedField =
    SYNCED_FIELDS.includes(
      field.name_ru
    );

  if (isSyncedField) {

    isDisabled = true;
  }

  // 🔥 parent_field логика
  if (field.parent_field) {
    const parentValue = formData?.[field.parent_field];

    const isEmpty =
      parentValue === undefined ||
      parentValue === null ||
      parentValue === "" ||
      parentValue === false ||
      parentValue === "false" ||
      parentValue === 0 ||
      parentValue === "0";

    if (isEmpty) {
      isDisabled = true;
    }
  }

  const handleChange = (val) => {
    onChange(val);
  };

  const syncedBadge = isSyncedField && (

    <div
      style={{
        marginTop: 4,
        fontSize: 12,
        color: "#6b7280",
      }}
    >

      🔒 Синхронизируется
      из данных клиники

    </div>
  );

  switch (field.field_type) {
    case "boolean":
      return (
        <input
          type="checkbox"
          checked={!!value}
          disabled={isDisabled || !isEditing}
          required={isRequired}
          onChange={(e) => handleChange(e.target.checked)}
        />
      );

    case "number":
      return (
        <div>
          <input
            type="number"
            value={value || ""}
            disabled={isDisabled || !isEditing}
            required={isRequired}

            style={{
              backgroundColor:
                isSyncedField
                  ? "#f3f4f6"
                  : undefined,
            }}

            onChange={(e) => handleChange(e.target.value)}
          />
          {syncedBadge}
        </div>
      );

    case "date":
      return (
        <input
          type="date"
          value={value || ""}
          disabled={isDisabled || !isEditing}
          required={isRequired}

          style={{
            backgroundColor:
              isSyncedField
                ? "#f3f4f6"
                : undefined,
          }}

          onChange={(e) => handleChange(e.target.value)}
        />
      );

    case "email":
      return (
        <div>
          <input
            type="email"
            value={value || ""}
            disabled={isDisabled || !isEditing}
            required={isRequired}

            style={{
              backgroundColor:
                isSyncedField
                  ? "#f3f4f6"
                  : undefined,
            }}

            onChange={(e) => handleChange(e.target.value)}
          />
          {syncedBadge}
        </div>
      );


    case "phone":
      return (
        <div>
          <input
            type="tel"
            value={value || ""}
            disabled={isDisabled || !isEditing}
            required={isRequired}
            placeholder="+992XXXXXXXXX"

            style={{
              backgroundColor:
                isSyncedField
                  ? "#f3f4f6"
                  : undefined,
            }}

            onChange={(e) => onChange(e.target.value)}
          />
          {syncedBadge}
        </div>
      );

    case "inn":
      return (
        <div>
          <input
            type="text"
            placeholder="ИНН"
            value={value || ""}
            maxLength={9}
            disabled={isDisabled || !isEditing}
            required={isRequired}

            style={{
              backgroundColor:
                isSyncedField
                  ? "#f3f4f6"
                  : undefined,
            }}

            onChange={(e) => handleChange(e.target.value)}
          />
          {syncedBadge}
        </div>
      );

    case "textarea":
      return (
        <div>
          <textarea
            value={value || ""}
            disabled={isDisabled || !isEditing}
            required={isRequired}

            style={{
              backgroundColor:
                isSyncedField
                  ? "#f3f4f6"
                  : undefined,
            }}

            onChange={(e) => handleChange(e.target.value)}
          />
          {syncedBadge}
        </div>
      );

    case "select":
      return (
        <div>
          <select
            value={value || ""}
            disabled={isDisabled || !isEditing}
            required={isRequired}

            style={{
              backgroundColor:
                isSyncedField
                  ? "#f3f4f6"
                  : undefined,
            }}

            onChange={(e) => handleChange(e.target.value)}
          >
            <option value="">
              {lang === "ru" ? "Выберите..." : "Интихоб кунед"}
            </option>

            {options.map((opt) => (
              <option key={opt.id} value={opt.id}>
                {lang === "ru"
                  ? opt.name_ru || opt.name
                  : opt.name_tj || opt.name}
              </option>
            ))}
          </select>
          {syncedBadge}
        </div>
      );

    case "multiselect": {
      const allowCustom = field.allow_custom === true;

      // 🔥 ищем "Другой"
      const OTHER_OPTION = options.find(
        (o) =>
          (o.name_ru || "").toLowerCase().includes("друг") ||
          (o.name_tj || "").toLowerCase().includes("дигар")
      );

      const hasOther =
        allowCustom &&
        Array.isArray(value) &&
        OTHER_OPTION &&
        value.some((v) => String(v) === String(OTHER_OPTION.id));

      return (
        <div>
          {/* 🔽 select */}
          <select
            multiple
            value={
              Array.isArray(value)
                ? value.filter((v) => typeof v !== "string")
                : []
            }
            disabled={isDisabled || !isEditing}
            required={isRequired}
            onChange={(e) => {
              const selected = Array.from(e.target.selectedOptions).map(
                (o) => o.value
              );

              const current = Array.isArray(value) ? value : [];

              // 🔥 объединяем старые + новые
              const merged = [...new Set([...current, ...selected])];

              handleChange(merged); // ✅ FIX (было selected)
            }}
          >
            {options.map((opt) => (
              <option key={opt.id} value={opt.id}>
                {lang === "ru"
                  ? opt.name_ru || opt.name
                  : opt.name_tj || opt.name}
              </option>
            ))}
          </select>

          {/* 🔥 chips */}
          <div
            style={{
              marginTop: 8,
              display: "flex",
              flexWrap: "wrap",
              gap: 6,
            }}
          >
            {(value || []).map((val, index) => {
              const found = options.find(
                (o) => String(o.id) === String(val)
              );

              const label = found
                ? lang === "ru"
                  ? found.name_ru || found.name
                  : found.name_tj || found.name
                : val;

              return (
                <div
                  key={index}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    background: "#e5e7eb",
                    padding: "4px 8px",
                    borderRadius: 16,
                  }}
                >
                  <span>{label}</span>

                  <span
                    style={{
                      marginLeft: 6,
                      cursor: "pointer",
                      color: "red",
                    }}
                    onClick={() => {
                      const newList = (value || []).filter((_, i) => i !== index); // ✅ FIX
                      handleChange(newList);
                    }}
                  >
                   ×
                  </span>
                </div>
             );
            })}
          </div>

          {/* 🔥 custom input (ТОЛЬКО если выбран "Другой") */}
          {hasOther && isEditing && (
            <div style={{ marginTop: 8 }}>
              <input
                type="text"
                value={customValue}
                placeholder={lang === "ru" ? "Введите..." : "Ворид кунед..."}
                onChange={(e) => setCustomValue(e.target.value)}
                style={{ marginRight: 8 }}
                onKeyDown={(e) => {
                  // 🔥 ENTER = добавить
                  if (e.key === "Enter") {
                    e.preventDefault();

                    const val = customValue.trim();
                    if (!val) return;

                    handleChange([
                      ...(Array.isArray(value) ? value : []),
                      val,
                    ]);

                    setCustomValue("");
                  }

                  // 🔥 BACKSPACE = удалить последний
                  if (
                    e.key === "Backspace" &&
                    !customValue &&
                    Array.isArray(value) &&
                    value.length > 0
                  ) {
                    handleChange(value.slice(0, -1));
                  }
                }}
              />
            </div>
          )}
        </div>
      );
    }

    case "working_hours": {
      const daysList = [
        { key: "mon", label: lang === "ru" ? "Пн" : "Дш" },
        { key: "tue", label: lang === "ru" ? "Вт" : "Сш" },
        { key: "wed", label: lang === "ru" ? "Ср" : "Чш" },
        { key: "thu", label: lang === "ru" ? "Чт" : "Пш" },
        { key: "fri", label: lang === "ru" ? "Пт" : "Ҷм" },
        { key: "sat", label: lang === "ru" ? "Сб" : "Шб" },
        { key: "sun", label: lang === "ru" ? "Вс" : "Як" },
      ];

      const current =
        value && typeof value === "object"
          ? value
          : { days: [], from: "", to: "" };

      const toggleDay = (day) => {
        const exists = current.days.includes(day);

        const newDays = exists
          ? current.days.filter((d) => d !== day)
          : [...current.days, day];

        handleChange({
          ...current,
          days: newDays,
        });
      };

      const updateTime = (field, val) => {
        handleChange({
          ...current,
          [field]: val,
        });
      };

      return (
        <div>
          {/* 🔹 ДНИ */}
          <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
            {daysList.map((d) => (
              <label key={d.key}>
                <input
                  type="checkbox"
                  checked={current.days.includes(d.key)}
                  onChange={() => toggleDay(d.key)}
                  disabled={isDisabled || !isEditing}
                />
                {d.label}
              </label>
            ))}
          </div>

          {/* 🔹 ВРЕМЯ */}
          <div style={{ marginTop: 10 }}>

            <input
              type="text"
              placeholder="СС:ДД"
              value={current.from || ""}
              onChange={(e) => updateTime("from", e.target.value)}
              disabled={isDisabled || !isEditing}
              style={{ width: 80 }}
            />

            {" — "}

            <input
              type="text"
              placeholder="СС:ДД"
              value={current.to || ""}
              onChange={(e) => updateTime("to", e.target.value)}
              disabled={isDisabled || !isEditing}
              style={{ width: 80 }}
            />

          </div>
        </div>
      );
    }


    case "array": {
      let list = [];

      if (Array.isArray(value) && value.length > 0) {
        list = value.flat();
      }
      else if (Array.isArray(field?.multi_values)) {
        list = field.multi_values.flatMap((v) =>
          Array.isArray(v.value) ? v.value : [v.value]
        );
      }

      return (
        <ArrayInput
          value={list}
          onChange={(newValues) => {
            onChange([...newValues]); // 🔥 обязательно копия
          }}
          lang={lang}
        />
      );
    }
    case "region":
    case "district":
      return (
        <RegionDistrictInput
          field={field}
          value={value}
          disabled={isDisabled || !isEditing}
          required={isRequired}
          formData={formData}
          onChange={onChange}
          lang={lang}
        />
      );

    default:
      return (
        <input
          type="text"
          value={value || ""}
          disabled={isDisabled || !isEditing}
          required={isRequired}
          onChange={(e) => handleChange(e.target.value)}
        />
      );
  }
}

function ArrayInput({ value, onChange, lang }) {
  const [input, setInput] = useState("");

  const list = Array.isArray(value) ? value : [];

  const addItem = () => {
    const val = input.trim();
    if (!val) return;

    if (!list.includes(val)) {
      onChange([...list, val]);
    }

    setInput("");
  };

  const removeItem = (index) => {
    const newList = list.filter((_, i) => i !== index);
    onChange(newList);
  };

  return (
    <div style={{ border: "1px solid #ddd", padding: 6, borderRadius: 6 }}>
      
      {/* 🔥 chips */}
      <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
        {list.map((item, index) => (
          <div
            key={index}
            style={{
              display: "flex",
              alignItems: "center",
              background: "#e5e7eb",
              padding: "4px 8px",
              borderRadius: 16,
              fontSize: 13,
            }}
          >
            <span>{item}</span>

            <span
              style={{
                marginLeft: 6,
                cursor: "pointer",
                color: "#ef4444",
                fontWeight: "bold",
              }}
              onClick={() => removeItem(index)}
            >
              ×
            </span>
          </div>
        ))}

        {/* 🔥 input */}
        <input
          value={input}
          onChange={(e) => setInput(e.target.value)}
          placeholder={
            lang === "ru"
              ? "Введите..."
              : "Ворид кунед..."
          }
          style={{
            border: "none",
            outline: "none",
            minWidth: 120,
          }}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
              addItem();
            }

            // 🔥 удаление последнего по Backspace
            if (e.key === "Backspace" && !input && list.length > 0) {
              removeItem(list.length - 1);
            }
          }}
        />
      </div>
    </div>
  );
}
